import parse from 'html-react-parser';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { DismissButton, MessageContainer, MessageText, RightContainer } from '../CustomToast/CustomToast.styles';
import {
  ButtonsContainer,
  InfoContainer,
  StyledButton,
  StyledIconContainer,
  StyledSecondaryButton,
  TimeText,
} from './CustomToastContent.styles';

interface CustomToastContentProps {
  message?: string;
  messageHtml?: string;
  icon?: ReactNode;
  image?: ReactNode;
  infoComponent?: ReactNode;
  dateCreatedAt?: Date;
  submitButtonTitle?: string;
  onDismiss?: () => void;
  onSubmit?: () => void;
}

const CustomToastContent = ({
  message,
  messageHtml,
  icon,
  image,
  dateCreatedAt,
  submitButtonTitle,
  onDismiss,
  onSubmit,
  infoComponent,
}: CustomToastContentProps) => {
  const { t } = useTranslation();

  const parseHtmlMessage = (message: string) => {
    try {
      return parse(message);
    } catch {
      return message;
    }
  };

  return (
    <MessageContainer>
      {image || (icon && <StyledIconContainer>{icon}</StyledIconContainer>)}
      <InfoContainer>
        <RightContainer>
          <MessageText>{messageHtml ? parseHtmlMessage(messageHtml) : message}</MessageText>
          {infoComponent}
          {dateCreatedAt && (
            <TimeText>
              {new Date(dateCreatedAt).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}
            </TimeText>
          )}
        </RightContainer>
        {submitButtonTitle ? (
          <ButtonsContainer>
            <StyledSecondaryButton onPress={onDismiss}>{t('subscriptions.dismiss')}</StyledSecondaryButton>
            <StyledButton onPress={onSubmit}>{submitButtonTitle}</StyledButton>
          </ButtonsContainer>
        ) : (
          <DismissButton onClick={onDismiss}>{t('subscriptions.dismiss')}</DismissButton>
        )}
      </InfoContainer>
    </MessageContainer>
  );
};

export default CustomToastContent;
